
export const signUpUser = async (password, email, phone, name, callback) => {
    const API_URL = process.env.REACT_APP_API_URL;
    try {
        const response = await fetch(`${API_URL}/signup`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                email,
                password,
                phone,
                name,
            }),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.detail || "회원가입 실패");
        }

        console.log("회원가입 성공:", data);

        // 이메일 인증 안내 메시지 표시
        callback(null, `${data.message} 이메일을 확인하고 인증을 완료해주세요.`);
    } catch (error) {
        console.error("회원가입 실패:", error.message);
        callback(error.message, null);
    }
};